import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Wrapper, Header, FirstTextWrapper, Title, MainText, LargeCircle, MediumCircle, SmallCircle, ImageWrapper, Image } from "./VocabularyStyle"
import picture from "./home.jpg"
import FrameComponent from "./01_frames/Frame"
import Memorizing from "./03_memorizing/Memorizing"
import { OneThousand } from "./OneThousand";
import { fetchVocabWords } from "../../features/vocab/vocabSlice";
import { vocabulary } from "../../i18n/05_vocabulary";


const Vocabulary = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = vocabulary[lang]


    const dispatch = useDispatch()
    const currentLesson = useSelector((s) => s.lesson.currentLesson); // used as lessonId
    const { words, loading, error } = useSelector(state => state.vocab);

    const unlockedCount = useSelector(
        (s) => (s.studentLessons?.lessons || []).filter((l) => l.isUnlocked).length
    );

    const lessonsLoaded = useSelector(
        (s) => (s.studentLessons?.lessons || []).length > 0
    );

    const role = useSelector((s) => s.auth?.user?.role);

    const [oneThousand, setOneThousand] = useState(
        role === undefined ? OneThousand.filter((val) => val.id < 36) : words

    )

    const [startTestMode, setStartTestMode] = useState(false)
    const [listOfWordsMode, setListOfWordsMode] = useState(false)


    useEffect(() => {
        // Teachers/admins can load immediately
        if (role !== "STUDENT") {
            dispatch(fetchVocabWords({ lessonId: "all" }));
            return;
        }

        // Students: wait until lessons are loaded so filtering can be correct
        if (!lessonsLoaded) return;

        dispatch(fetchVocabWords({ lessonId: "all" }));
    }, [dispatch, role, lessonsLoaded, unlockedCount]);

    useEffect(() => {
        if (!role) {
            setOneThousand(OneThousand.filter((val) => val.id < 36));
        } else {
            setOneThousand(words);
        }
    }, [role, words]);

    return (
        <Wrapper>
            <Header>
                {t.header}
            </Header>
            <FirstTextWrapper>
                <Title>{t.title}</Title>
                <MainText>
                    {t.mainText}
                </MainText>
            </FirstTextWrapper>
            {role && loading && <p>Loading vocabulary...</p>}
            {role && error && <p style={{ color: "red" }}>{String(error)}</p>}

            <FrameComponent

                startTestMode={startTestMode}
                listOfWordsMode={listOfWordsMode}
                oneThousand={oneThousand}           // now DB words
                setOneThousand={setOneThousand}
            />
            <LargeCircle />
            <MediumCircle />
            <SmallCircle />
            <ImageWrapper>
                <Image src={picture} />
            </ImageWrapper>
            <FirstTextWrapper>
                <Title>{t.memorizingTitle}</Title>
            </FirstTextWrapper>

            <Memorizing />
        </Wrapper>
    )
}

export default Vocabulary


